import React, { Component } from "react";
import "./Home.css";
import HomeIcon from "@material-ui/icons/Home";
import ApartmentIcon from "@material-ui/icons/Apartment";
// import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

export class Home extends Component {
  render() {
    return (
      <div className="root-container">
        <div className="type--container appartment--container">
          <ApartmentIcon />
          <a href="/cdp">Carte des prix</a>
        </div>
        <div className="type--container villa--container">
          <HomeIcon />
          <a href="/valuation"> Valuation </a>
        </div>

      </div>
    );
  }
}

export default Home;
